// Configuration file for easy updates
export const CONFIG = {
    COMPANY: {
        NAME: 'Print Studio',
        EMAIL: 'contacto@printstudio.com',
        PHONE: '+52 (56) 6565-0290',
        ADDRESS: 'CDMX y Área Metropolitana',
        WHATSAPP: {
            NUMBER: '525665650290',
            DEFAULT_MESSAGE: 'Hola, Print Studio, quisiera saber más de sus servicios.'
        }
    },
    SOCIAL_MEDIA: {
        INSTAGRAM: '#',
        FACEBOOK: '#',
        LINKEDIN: '#',
        TWITTER: '#'
    }
};

// Helper function to generate WhatsApp URL
export const getWhatsAppUrl = (message = null) => {
    const encodedMessage = encodeURIComponent(message || CONFIG.COMPANY.WHATSAPP.DEFAULT_MESSAGE);
    return `https://wa.me/${CONFIG.COMPANY.WHATSAPP.NUMBER}?text=${encodedMessage}`;
};